import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function Circle(props) {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path
        d="M8 0.25C3.71875 0.25 0.25 3.71875 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.2812 15.75 15.75 12.2812 15.75 8C15.75 3.71875 12.2812 0.25 8 0.25ZM14.75 8C14.75 11.7188 11.7188 14.75 8 14.75C4.28125 14.75 1.25 11.75 1.25 8C1.25 4.3125 4.25 1.25 8 1.25C11.6875 1.25 14.75 4.28125 14.75 8Z"
      />
    </SvgIcon>
  );
}
